<template>
  <div class="kpt-detail-content-page">
    <vue-headful :title="`${device.name}`" />
    <div class="kpt-detail-content-actions">
      <div class="buttons">
        <b-button type="is-primary is-outlined" icon-left="sync-alt" size="is-small" :disabled="isRefreshing" @click="fetchDeviceGroups">Refresh</b-button>
        <b-button type="is-primary is-outlined" 
          size="is-small" 
          @click="openGroupCreate"
          icon-left="users-cog" 
          v-if="!isSharedDevice && $hasRole('Super User,Kymeta Admin,Product Support,Account Admin')">Create Group</b-button>
      </div>
    </div>
    <div class="kpt-device-groups-container">
      <header>
        <h6 class="is-uppercase"><strong>groups</strong></h6>
      </header>
      <!-- Table -->
      <div class="kpt-device-groups-table">
        <b-table
          :data="deviceGroups"
          :narrowed="true"
          :hoverable="true"
          :loading="isLoadingGroups"
          default-sort-direction="desc"
          default-sort="timestamp"
          sort-icon="chevron-up"
          sort-icon-size="is-small"
          ref="deviceGroupTable"
          class="has-horizontal-scroll is-full-height">
          <b-table-column field="name" label="Name" v-slot="props" sortable>
              <router-link :to="{ name: 'groupOverview', params: { id: props.row.id } }">{{props.row.name}}</router-link>
          </b-table-column>
          <b-table-column field="sharedWith" label="Shared With" v-slot="props" sortable>
             {{props.row.sharedWith && props.row.sharedWith[0] ? getAccountName(props.row.sharedWith[0].id) : ''}}
          </b-table-column>
          <template slot="empty">
            <p v-if="!isLoadingGroups">No group records found.</p>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import { orderBy } from 'lodash';

export default {
  data() {
    return {
      deviceGroups: [],
      isLoadingGroups: true
    }
  },
  async mounted() {
    // fetch groups for device
    await this.fetchDeviceGroups();
  },
  computed: {
    device() {
      return this.$store.state.devices.device;
    },
    isRefreshing() {
      return this.$store.state.devices.deviceRefreshing;
    },
    accounts() { return orderBy(this.$store.state.accounts.accounts, ['name'], ['asc']); },
    isSharedDevice() {
      // flatten array to just account id's
      const hierarchyAccountIds = this.accounts.map(a => a.id);
      // check to see if the device account matches the users account hierarchy
      const hierarchyAccountFound = hierarchyAccountIds.includes(this.device.accountId);
      return !hierarchyAccountFound;
    }
  },
  methods: {
    async fetchDeviceGroups() {
      // verify device properties
      if (!this.device) {
        this.$buefy.toast.open({
          duration: 2500,
          message: 'Device not found.',
          type: 'is-danger'
        });
        return;
      }

      this.isLoadingGroups = true;
      const payload = { 
        entityId: this.device.id,
        entityType: 'device'
      }
      // fetch device group data
      const groupsResult = await this.$store.dispatch('fetchDeviceGroups', payload);
      this.isLoadingGroups = false;
      if (!groupsResult) {
        this.$buefy.toast.open({
          duration: 2500,
          message: 'Error fetching device groups.',
          type: 'is-danger'
        });
        // early exit if no group data found 
        return;
      }
      this.deviceGroups = groupsResult;
    },
    openGroupCreate() {
      // add this device to vuex state as a pre-selected entity for group creation
      this.$store.commit('assignPreselectedEntity', { 
        id: this.device.id,
        accountId: this.device.accountId,
        serial: this.device.serial,
        deviceModelName: this.device.deviceModel,
        deviceTypeName: this.device.deviceType
      });

      // route the user to create group wizard
      this.$router.push({ name: 'groupCreate', params: { entityType: 'device', groupOwnerId: this.device.accountId } });
    },
    getAccountName(id) {
      const account = this.accounts.find(a => a.id == id);
      return account ? account.name : '-';
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
